import ProductHorizontalCards, { HorizontalCardsItem } from "@/app/parts/product/ProductHorizCards";
import productDetail from "@/styles/modules/product_detail.module.scss";
import * as Api from "@api";
import * as C from "@components";
import clsx from "clsx";
import React from "react";

const ProductEngineeringHeadingPageKeys = [
    "engineering.headline",
    "engineering.body",
] as const;

export const ProductEngineeringPageKeys = [
    ...ProductEngineeringHeadingPageKeys,
    "engineering.1.headline",
    "engineering.1.body",
    "engineering.2.headline",
    "engineering.2.body",
    "engineering.3.headline",
    "engineering.3.body",
    "engineering.4.headline",
    "engineering.4.body",
] as const;

interface ProductEngineeringSectionProps 
{
    imageUrls?: { [key in "1" | "2" | "3" | "4"]?: string };
    imageMobileUrls?: { [key in "1" | "2" | "3" | "4"]?: string };
    pageContent: Api.Content<typeof ProductEngineeringPageKeys[number]>;
    hideKeyCards?: number[];
    className?: string;
}

export const ProductEngineeringSection = ({ imageUrls, imageMobileUrls, pageContent, hideKeyCards, className }: ProductEngineeringSectionProps): React.FunctionComponentElement<ProductEngineeringSectionProps> =>
{
    const classes = clsx(
        productDetail.product_detail,
        className
    );

    const imageDirectory = "/images/products/@global/sections/engineering/";
    let horizontalCards: HorizontalCardsItem[] = [
        {
            title: <C.PageContent {...pageContent["engineering.1.headline"]} margins={{ bottom: C.Margin.D30 }} typography={C.Typography.H5} />,
            description: pageContent["engineering.1.body"].data,
            imageSrc: imageUrls?.["1"] ?? `${imageDirectory}horcard1.png`,
            imageHeight: 330,
            imageWidth: 330,
            imageMobileSrc: imageMobileUrls?.["1"] ?? imageUrls?.["1"] ?? `${imageDirectory}m-horcard1.png`, 
            imageMobileHeight: 300,
            imageMobileWidth: 200,
            alt: 'Flavor preservation' 
        },
        {
            title: <C.PageContent {...pageContent["engineering.2.headline"]} margins={{ bottom: C.Margin.D30 }} typography={C.Typography.H5} />,
            description: pageContent["engineering.2.body"].data,
            imageSrc: imageUrls?.["2"] ?? `${imageDirectory}horcard2.png`,
            imageHeight: 330,
            imageWidth: 330,
            imageMobileSrc: imageMobileUrls?.["2"] ?? imageUrls?.["2"] ?? `${imageDirectory}m-horcard2.1.png`, 
            imageMobileHeight: 300,
            imageMobileWidth: 200,
            alt: 'No-Burn Technology®'
        },
        {
            title: <C.PageContent {...pageContent["engineering.3.headline"]} margins={{ bottom: C.Margin.D30 }} typography={C.Typography.H5} />,
            description: pageContent["engineering.3.body"].data,
            imageSrc: imageUrls?.["3"] ?? `${imageDirectory}horcard3.png`,
            imageHeight: 330,
            imageWidth: 330,
            imageMobileSrc: imageMobileUrls?.["3"] ?? imageUrls?.["3"] ?? `${imageDirectory}m-horcard3.png`,
            imageMobileHeight: 300,
            imageMobileWidth: 200,
            alt: 'Smooth vaping'
        },
        {
            title: <C.PageContent {...pageContent["engineering.4.headline"]} margins={{ bottom: C.Margin.D30 }} typography={C.Typography.H5} />,
            description: pageContent["engineering.4.body"].data,
            imageSrc: imageUrls?.["4"] ?? `${imageDirectory}horcard4.png`,
            imageHeight: 330,
            imageWidth: 330,
            imageMobileSrc: imageMobileUrls?.["4"] ?? imageUrls?.["4"] ?? `${imageDirectory}m-horcard4.png`, 
            imageMobileHeight: 300,
            imageMobileWidth: 200,
            alt: 'Even heating'
        },
    ];
    if ( hideKeyCards) {
        horizontalCards = horizontalCards.filter((card, index) => {
             return hideKeyCards.indexOf(index + 1) === -1;
        });
    }

    return (
        <div className={classes}>
            <div className={productDetail.product_slider_cards}>
                <div className="container">
                    <C.SideBySideText
                        keys={ProductEngineeringHeadingPageKeys}
                        items={{
                            "engineering.headline": { typography: C.Typography.H2, maxWidth: C.Width.W684 },
                            "engineering.body": { typography: C.Typography.P1, maxWidth: C.Width.W386 }
                        }}
                        layout={{ all: { margins: { bottom: C.Margin.D20 } }, ipad: { margins: { bottom: C.Margin.D60 } } }}
                        pageContent={pageContent}
                    />
                    <ProductHorizontalCards items={horizontalCards} />
                </div>
            </div>
        </div>
    )
}